import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { AiFilterChip } from '~/components/AiSearchChips/AiFilterChip/AiFilterChip';
import { ChipConnector } from '~/components/AiSearchChips/ChipConnector/ChipConnector';
import { setCollectionQuantifier } from '~/components/AiSearchChips/collection-predicate';
import { FilterChip } from '~/components/AiSearchChips/FilterChip/FilterChip';
import { useSettingsChipTone } from '~/components/AiSearchChips/settingsChipTone';
import { currentValue } from '~/components/AiSearchChips/StringMatchChip/StringMatchChip.utils';
import { isSingleNameCollection, namedCollectionFromInput, pureOrNamePills, removeOrArm } from './CollectionChips.utils';
import { CollectionConditionChip } from './CollectionConditionChip/CollectionConditionChip';
export const CollectionQuantifierChips = (param)=>{
    let { testIds, labels, collection, grammar, quantifier, predicate, operator, onToggleQuantifier, onChange } = param;
    const tone = useSettingsChipTone();
    const orPills = pureOrNamePills(predicate);
    const removeQuantifier = ()=>onChange(setCollectionQuantifier(collection, quantifier, undefined));
    const removeArm = (armIndex)=>onChange(removeOrArm(collection, quantifier, predicate, armIndex));
    const orPillProps = (pill)=>({
            testId: testIds.orPill(pill.armIndex),
            fieldLabel: labels.field,
            operator,
            valueLabel: pill.valueLabel,
            onRemove: ()=>removeArm(pill.armIndex),
            removeBiName: grammar.bi.remove,
            tone
        });
    if (orPills != null) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: orPills.map((pill, pillIndex)=>/*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        pillIndex > 0 && /*#__PURE__*/ _jsx(ChipConnector, _object_spread_props(_object_spread({}, grammar.connector), {
                            testId: testIds.orPillConnector(pill.armIndex),
                            tone: "or"
                        })),
                        /*#__PURE__*/ _jsx(FilterChip, _object_spread({}, orPillProps(pill)))
                    ]
                }, pill.armIndex))
        });
    }
    const name = predicate.name;
    if (isSingleNameCollection(predicate) && name != null) {
        return /*#__PURE__*/ _jsx(AiFilterChip, {
            mode: "text",
            testId: testIds.chip,
            fieldLabel: labels.field,
            value: currentValue(name),
            operator: operator,
            tone: tone,
            onApply: (value)=>onChange(namedCollectionFromInput({
                    collection,
                    quantifier,
                    predicate,
                    value
                })),
            onRemove: removeQuantifier,
            biPrefix: grammar.bi.prefix,
            texts: {
                apply: grammar.texts.applyButton()
            }
        });
    }
    return /*#__PURE__*/ _jsx(CollectionConditionChip, {
        testId: testIds.chip,
        fieldLabel: labels.field,
        nounLabel: labels.noun,
        quantifier: quantifier,
        predicate: predicate,
        grammar: grammar,
        onToggleQuantifier: onToggleQuantifier,
        onRemove: removeQuantifier
    });
};
